import axios from 'axios';
import { isApiError } from '@project/API/utils';

// TODO:
export const createInstance = (basePath: string) => {
  const instance = axios.create({ baseURL: basePath + '/api/' });

  instance.interceptors.response.use(
    async (request) => {
      return request;
    },
    (e) => {
      const data = e?.response?.data;

      if (isApiError(data)) {
        const error = new Error(data.detail);

        return Promise.reject(error);
      }

      return Promise.reject(e);
    },
  );

  return instance;
};
